import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    forwardRef,
    inject,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {
    ControlContainer,
    ControlValueAccessor,
    FormControl,
    FormControlDirective,
    NG_VALUE_ACCESSOR
} from '@angular/forms';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateFormat, DateParserFormatter } from '@services/date-parser';
//import { NationService } from '@services/nation';
//import { DateFormat } from '@services/nation/nation.model';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true
        },
        { provide: NgbDateParserFormatter, useClass: DateParserFormatter }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
    @ViewChild(FormControlDirective, { static: true })
    public formControlDirective: FormControlDirective;

    @Input()
    public formControlName: string;
    @Input()
    public readonly: boolean = false;
    @Input() public highlightAnimated: boolean = false;
    @Input() public highlightFocused: boolean = false;
    @Output() public changed: EventEmitter<NgbDate> = new EventEmitter<NgbDate>();
    @Output() public highlightFocus = new EventEmitter<void>();

    public datePlaceholder = '';
    public readonly formatter = inject(DateParserFormatter);
    //private readonly nationService = inject(NationService);

    private readonly controlContainer = inject(ControlContainer);

    public get control() {
        return this.controlContainer.control.get(this.formControlName) as FormControl<boolean>;
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public onTouched = (): void => {};

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public onChange: (date: NgbDate) => void = (date) => {
        this.changed.emit(date);
    };

    public registerOnChange(fn: (value: boolean) => boolean): void {
        this.formControlDirective.valueAccessor.registerOnChange(fn);
    }

    public registerOnTouched(fn: () => void): void {
        this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }

    public writeValue(value: NgbDate): void {
        this.formControlDirective.valueAccessor.writeValue(value);
    }

    public ngOnInit() {
        this.datePlaceholder = this.formatter.dateFormats[DateFormat.LongDate].placeholder;
        //this.datePlaceholder = this.nationService.getDateFormat(DateFormat.LongDate).placeholder;
    }

    public onHighlightFocus() {
        this.highlightFocus.emit();
    }
}
